//
//  SDKGradientType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var GradientType;
(function (GradientType) {
    GradientType["linear"] = "Linear";
    GradientType["radial"] = "Radial";
    GradientType["angular"] = "Angular";
})(GradientType || (GradientType = {}));
